export default __webpack_public_path__ + "static/media/cert-general-staff-hkgcsmeaa-sc.7bdeeb19.jpg";